import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Lessons from "./components/lessons/Lessons";
import About_Us from "./components/about_us/About_Us";
import Register from "./components/register/Register";
import Contact_us from "./components/Contact_us/Contact_us";
import Terms_and_condition from "./components/terms_and_condition/Terms_and_condition";
import Privacy_policy from "./components/privacy_policy/Privacy_policy";
import Profile from "./components/profile/Profile";
import ScrollToTop from "./components/ScrollTotop/ScrollTotop";

function App() {
  const location = useLocation();

  // Hide header & footer only on /register
  const hideLayout = location.pathname === "/register";

  return (
    <>
      <ScrollToTop />
      {!hideLayout && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/courses" element={<Lessons />} />
        <Route path="/register" element={<Register />} />
        <Route path="/contact-us" element={<Contact_us />} />
        <Route path="/terms-ans-conditions" element={<Terms_and_condition />} />
        <Route path="/privacy-policy" element={<Privacy_policy />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
      {!hideLayout && <Footer />}
    </>
  );
}

export default App;
